import { createContext, createRef, RefObject, useContext } from 'react'
import { CreateEventOverlayRef, VisitsCalendarContextData } from './types'

export const VisitsCalendarContext = createContext<VisitsCalendarContextData>({
  selectedDate: null,
  onSelectDate: () => {},
  onSelectNewVisit: () => {},
  newVisitArgs: null,
  onCloseNewVisit: () => {},
  practiceId: null,
  handleDateClick: () => {},
  handleEventClick: () => {},
  handleDatesSet: () => {},
  visits: { data: null, dataArr: [], loading: false, error: null },
  visitDrafts: { data: null, dataArr: [], loading: false, error: null },
  events: [],
  createEventOverlayRef: createRef() as RefObject<CreateEventOverlayRef>,
})

export const useVisitsCalendar = () => useContext(VisitsCalendarContext)
